
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.79 7.04v1.038H4.382c-.552 0-1.021-.029-1.406-.086a4.187 4.187 0 01-.993-.273 3.004 3.004 0 01-.789-.532 3.087 3.087 0 01-.593-.75 3.461 3.461 0 01-.329-.906 5.041 5.041 0 01-.109-1.078c0-.937.167-1.659.5-2.164.333-.51.779-.896 1.336-1.156.563-.26 1.393-.39 2.492-.39H9.79V1.78H4.547c-.6 0-1.068.037-1.406.11a2.284 2.284 0 00-.868.351c-.234.162-.43.414-.586.758-.156.339-.234.794-.234 1.367 0 .495.052.909.156 1.242.105.329.271.605.5.829.23.218.521.375.875.468.36.089.85.133 1.47.133h5.335z","fill":"currentColor"}})])
          )
        }
      }
    